import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Divider, List, ListItem, ListItemText, Typography } from '@mui/material';
import Info from '@mui/icons-material/Info';

import CardHeader from '../../DesignSystem/CardHeader';
import { CloudinaryConfig, cloudinaryImageUrl } from '../../../Services/Cloudinary';
import Alert from '../../DesignSystem/Alert';
import AuditDiff from './AuditDiff';
import { moment } from '../../../I18n';
import { fieldNameFromKey } from '../../../Utils/audits';

function AuditsList({ audits }: any) {
  const intl = useIntl();

  if (audits.length === 0) {
    return (
      <Box sx={{ m: 4 }}>
        <Alert severity="info" icon={<Info />}>
          <FormattedMessage id="POSTS.AUDITS.NO_AUDITS" />
        </Alert>
      </Box>
    );
  }

  return (
    <List>
      {audits.map((audit: any, index: any) => (
        <>
          <ListItem key={audit.created_at} sx={{ mt: 2, width: '100%', display: 'block' }}>
            {audit.user && (
              <CardHeader
                profilePictureUrl={cloudinaryImageUrl(
                  audit.user?.picture?.s3_key,
                  CloudinaryConfig.AVATAR_48,
                  audit.user?.picture?.title,
                )}
                fullName={audit.user.full_name}
                initials={audit.user.initials}
                subheader={intl.formatMessage(
                  { id: `POSTS.AUDITS.${audit.action.toUpperCase()}` },
                  { date: moment(audit.created_at).fromNow() },
                )}
                alt="author avatar"
              />
            )}

            <List>
              {Object.entries(audit.changes || {})
                // get the proper name of the fields (translated fields for example: title_fr => title)
                .map(([key, value]) => [fieldNameFromKey(key), value])
                // sort the fields
                .map(([key, value]) => {
                  return (
                    <ListItem key={key}>
                      <ListItemText
                        primary={
                          <Typography variant="subtitle2">
                            <FormattedMessage id={`POST_FORM.${key.toUpperCase()}`} />
                          </Typography>
                        }
                        secondary={<AuditDiff diff={value} />}
                      />
                    </ListItem>
                  );
                })}
            </List>
          </ListItem>
          {index < audits.length - 1 && <Divider />}
        </>
      ))}
    </List>
  );
}

export default AuditsList;
